export const ProgrammingSkills = [
  { language: "Javascript", progress: "90" },
  { language: "Python", progress: "80" },
  { language: "C", progress: "70" },
];

export const MarkUpSkills = [
  { language: "HTML5", progress: "95" },
  { language: "CSS3", progress: "90" }
];

export const Frameworks = [
  {
    language: "Javascript",
    frameworks: "React, React-Native, Node, Express, Redux, Context"
  },
  { language: "Python", frameworks: "Flask" },
  { language: "CSS3", frameworks: "SASS, SCSS" },
  { language: "Swift", frameworks: "Swift UI" }
];

export const Databases = ["MongoDb", "MySQL"];
export const Caches = ["Redis", "RabbitMQ"];

export const Tools = ["Git", "GitHub", "Gitlab", "Webpack", "NPM", "NVM", "Yarn"];

export const IDE = [
  "VSCode",
  "XCode",
  "Android Studio",
  "IntelliJ IDE",
  "Sublime Text",
];

export const Tech = ["Angular", "DSA", "AWS"];

export const Name = "GAUTAM MISHRA";
export const PhoneNumber = "+91-8707853340";
export const whatAppNumber = "+91-8545048032";
export const EmailAddress = "gautamjansa@gmail.com";
export const Home = "Mumbai, INDIA";
// • Coding Platforms: HackerEarth, HackerRank, CodeChef, TopCoder, Github.

//Experience
export const ExperienceObject = [
  {
    company: "Coalescence Technologies",
    date: "Sep 2021 – Present",
    role: "Sr. Software Engineer (Full stack developer)",
    imageSrc:
      "https://media.licdn.com/dms/image/C4E0BAQHWq9HBaNpGSA/company-logo_200_200/0/1603924726074?e=2147483647&v=beta&t=2_b5NJZ5JVFTq1pmiE4GP-sOor0I39556ofsrzK_tZI",
    desc: "Working for Coalescence Technologies in a complete agile environment. Responsible for designing and implementing new innovative features and functionalities, establishing the MongoDB, Express, React and Node.js - MERN Stack website’s architecture, ensuring high-performance and availability, and managing all MERN Stack development & technical aspects. Wrrking with a Blockchain client and making back-end with Node, Express and Mongo doing inegration in front-end for them. I work closely with project stack holders and end customers to ensure an effective, visually appealing, and intuitive implementation. Also worked in app development with React-Native. Making from scratches to doing live on app store an play store. Also leading a team of 9 members to mentor, guide and assign them project tasks."
  },
  {
    company: "Coalescence Technologies",
    date: "March 2020 – Aug 2021",
    role: "Jr. Software Developer",
    imageSrc: "https://media.licdn.com/dms/image/C4E0BAQHWq9HBaNpGSA/company-logo_200_200/0/1603924726074?e=2147483647&v=beta&t=2_b5NJZ5JVFTq1pmiE4GP-sOor0I39556ofsrzK_tZI",
    desc: "Worked for Coalescence Technologies in a complete agile environment. Developed UI for Web applications with the React.js using Javascript with ES6/ES7 concepts. Writing tested document with React.js, JavaScript, HTML, CSS, SCSS. Made design and technical decisions for React projects/works. Writing routes in Backend, APIs."
  },
];

// Education

export const EducationObject = [
  {
    date: "AUG 2017 - JUNE 2020",
    role: "Masters in Computer Application (MCA)",
    college: "Galgotias Collage of Engineering & Technology, Greater Noida ",
    imageSrc:
      "data:image/png;base64,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",
    desc: `
      Got 8.46 CGPA .
      As a Master of Computer Applications student, I gained hands-on experience in various cutting-edge technologies and programming languages, including C, Python, and PHP. I also participated in group projects, honing my teamwork, problem-solving, and technical skills. I completed my final year project on 'ExamYantra' using PHP , demonstrating my ability to turn theoretical knowledge into practical solutions.`
  },
  {
    date: "JUL 2014 - JUNE 2017",
    role: "Bachelor of Science (B.Sc) - Mathematics",
    college: "Mahatma Gandhi Kashi Vidyapeeth University, Varanasi",
    imageSrc: "https://upload.wikimedia.org/wikipedia/en/thumb/d/d3/Mahatma_Gandhi_Kashi_Vidyapith_logo.png/220px-Mahatma_Gandhi_Kashi_Vidyapith_logo.png",
    desc: `
      As a Bachelor of Science student, I gained a strong foundation in various scientific disciplines, including mathematics, chemistry, and physics. I also participated in laboratory experiments, honing my technical and problem-solving skills, and presenting my findings in group presentations.`
  }
];

//Awards or certifications

export const AwardsObject = [
  {
    src:
      "https://i.postimg.cc/Z5hYTv5S/incapp-java-core.jpg",
    altText: "incapp!"
  },
  {
    src: "https://i.postimg.cc/g0B8Bbvr/Certificate-Gautam-Mishra-C.jpg",
    altText: "jiit_c"
  },
  {
    src: "https://i.postimg.cc/Fzp62KG0/Certificate-Gautam-Mishra-ADCA.jpg",
    altText: "jiit_adca"
  },
  {
    src: "https://i.postimg.cc/tRxLXXvd/ml-blockchain.jpg",
    altText: "ml_blockchain"
  },
  {
    src: "https://i.postimg.cc/wBR1WyFR/hacking.jpg",
    altText: "hacking"
  }
];

export const PRObject = [
  {
    repoName: "akka-http-quickstart-scala.g8",
    repoLink: "https://github.com/akka/akka-http-quickstart-scala.g8",
    pullRequest:
      "https://github.com/akka/akka-http-quickstart-scala.g8/pull/44",
    status: "Open"
  },
  {
    repoName: "docs.scala-lang",
    repoLink: "https://github.com/scala/docs.scala-lang",
    pullRequest: "https://github.com/scala/docs.scala-lang/pull/930",
    status: "Merged"
  },
  {
    repoName: "karma-firefox-launcher",
    repoLink: "https://github.com/karma-runner/karma-firefox-launcher",
    pullRequest:
      "https://github.com/karma-runner/karma-firefox-launcher/pull/84",
    status: "Merged"
  },
  {
    repoName: "akka-http",
    repoLink: "https://github.com/akka/akka-http",
    pullRequest: "https://github.com/akka/akka-http/pull/2099",
    status: "Merged"
  }
];

//About

export const GithubProjects = [
  {
    sr: "1",
    projectLink: "https://ovato.com/en",
    projectName: "Ovato Landing Page",
    languages: "React & Node"
  },
  {
    sr: "2",
    projectLink: "https://wallet.ovato.com/",
    projectName: "Ovato Web Wallet",
    languages: "React & Node"
  },
  {
    sr: "3",
    projectLink: "https://explorer.ovato.com/",
    projectName: "Ovato Blockchain Explorer",
    languages: "React, Node, Express & Mongo"
  },
  {
    sr: "4",
    projectLink: "https://apps.apple.com/us/app/ovato-wallet/id1520107226",
    projectName: "Ovato Wallet App - iOS",
    languages: "React Native, FCM, XCode"
  },
  {
    sr: "5",
    projectLink: "https://apps.apple.com/us/app/ovato-merchant-wallet/id1563552465",
    projectName: "Ovato Merchant App - iOS",
    languages: "React Native, FCM, XCode"
  },
  {
    sr: "6",
    projectLink: "https://play.google.com/store/apps/details?id=com.ovato.wallet&hl=en&gl=US",
    projectName: "Ovato Wallet App - Android",
    languages: "React Native, FCM, Android Studio"
  },
  {
    sr: "7",
    projectLink: "https://play.google.com/store/apps/details?id=com.merchantwalletapp&hl=en&gl=US&pli=1",
    projectName: "Ovato Merchant App - Android",
    languages: "React Native, FCM, Android Studio"
  },
  {
    sr: "8",
    projectLink: "https://github.com/MishraGautam/Shopping-Web",
    projectName: "Shopping Web Demo",
    languages: "React"
  },
  {
    sr: "9",
    projectLink: "https://github.com/MishraGautam/React-Memes",
    projectName: "React Memes Demo",
    languages: "React"
  },
  {
    sr: "10",
    projectLink: "https://github.com/MishraGautam/Redux-Ex",
    projectName: "React Redux Demo",
    languages: "React, Redux"
  },
];
